/* global window */

import React from 'react';
import { bool, object } from 'prop-types';
import { Tabs, Tab } from 'react-bootstrap';

import Breadcrumbs from './Breadcrumbs';
import WalletTransactions from './WalletTransactions';
import WalletPaymentMethods from './WalletPaymentMethods';

function Wallet({ user, userFetched, isLoggedIn }) {
    if (userFetched && !isLoggedIn) {
        window.location.assign('/login.asp');
    }

    return (
        <div
            className={'page--section'}
        >
            {!userFetched ? <div>Checking login status...</div> : null}
            {userFetched && !user ? <div>Redirect to login...</div> : null}
            {userFetched && user ? (
                <>
                    <Breadcrumbs
                        breadcrumbList={[
                            ['My Account', '/myaccount.asp' ],
                            ['Wallet', ''],
                        ]}
                    />
                    <Tabs
                        defaultActiveKey={'payment-methods'}
                        className={'mb-3'}
                    >
                        <Tab
                            eventKey={'payment-methods'}
                            title={'Payment methods'}
                        >
                            <WalletPaymentMethods
                                user={user}
                            />
                        </Tab>
                        <Tab
                            eventKey={'transactions'}
                            title={'Transaction History'}
                        >
                            <WalletTransactions
                                user={user}
                            />
                        </Tab>
                    </Tabs>
                </>
            ): null}
        </div>
    );
}

Wallet.propTypes = {
    user: object,
    userFetched: bool,
    isLoggedIn: bool,
};

export default Wallet;